import React, { useEffect, useMemo, useState } from "react"
import { Table, Row, Col, Card, CardBody, Button, Input, Modal, Form, Label } from "reactstrap"
import { useNavigate } from "react-router-dom"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import configure from "configure"
import Swal from "sweetalert2"
import Select from "react-select"
import addTeamsImg from "../../../../assets/images/addTeams.jpg"
import editTeamsImg from "../../../../assets/images/editTeams.jpg"
import "../../../../assets/css/Settings/Setting.css"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import { locationOptions, StaffOption } from "utils/common-options"
import {
  fetchNodeData,
  FetchNodePostData,
  FetchNodePutData,
  FetchNodeDeleteData,
} from "utils/common-fetchData"
import { Link } from "react-router-dom"
import secureLocalStorage from "react-secure-storage"
import { useSelector } from "react-redux"
import LeadCommunicatorIndex from "./LeadCommunicatorIndex"

function TableContainer({ columns, data, setAddTeam, setAccessDenied }) {
  const [fixedContent, setFixedContent] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      setFixedContent(window.scrollY > 300)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  return (
    <div>
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={() => setAddTeam(true)}
          className="btn btn-purple fix-btn"
        >
          <i className="fas fa-plus me-2 icon-size"></i>
          <span>Add</span>
        </button>
        <button onClick={() => navigate(-1)} className="btn btn-red fix-btn">
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col>
          <select
            className="form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end gap-2">
          <div className="me-4">
            <div className="search-box my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={() => setAddTeam(true)}
              className="btn btn-purple btn-label"
            >
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Add Lead Communicator
            </button>
          </div>
          <div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-red btn-label"
            >
              <i className="dripicons-cross icon-center me-2 label-icon"></i>
              CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead
          className={`${
            fixedContent && page.length >= 10 ? "fixed-oe-setting-header" : ""
          }`}
        >
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`${column.className} customShortIcon`}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                  {column.isInfoIcon ? (
                    <i
                      title="info"
                      className="bx bx-info-circle ms-1 info-icon"
                    ></i>
                  ) : null}
                  {column.isShortIcon && (
                    <span
                      onClick={() => column.getSortByToggleProps().onClick()}
                      className="ms-2 cursor-pointer"
                    >
                      <i
                        title="Ascending"
                        className={`bi bi-arrow-up info-icon ${
                          column.isSorted && !column.isSortedDesc
                            ? "text-dark"
                            : ""
                        }`}
                      ></i>
                      <i
                        title="Descending"
                        className={`bi bi-arrow-down info-icon ${
                          column.isSorted && column.isSortedDesc
                            ? "text-dark"
                            : ""
                        }`}
                      ></i>
                    </span>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => (
                  <td
                    className={cell.column.className}
                    key={index}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const LeadCommunicator = ({ verticalActiveTabs }) => {
  const [editTeams, setEditTeams] = useState(false)
  const [addTeam, setAddTeam] = useState(false)
  const [datas, setDatas] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [modal_Access, setAccessDenied] = useState(false)
  const [members, setMembers] = useState(null)
  const [country, setCountry] = useState(null)
  const [staffData, setStaffData] = useState([])
  const [id, setId] = useState("")
  const getLocations = useSelector(state => state?.location?.locations)

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isShortIcon: true,
        className: "text-center mt_id",
      },
      {
        Header: "Members",
        accessor: "members",
        isInfoIcon: true,
        isShortIcon: true,
        className: "",
        Cell: ({ row }) => (
          <div className="text-start">{row.original.members}</div>
        ),
      },
      {
        Header: "Country",
        accessor: "country_flag",
        className: "text-center oe-action",
        Cell: ({ row }) => (
          <div className="text-center">
            {row.original.country_flag ? (
              <img
                src={row.original.country_flag}
                alt="Country Map"
                style={{ width: "25px", height: "25px", objectFit: "contain" }}
                onError={(e) => (e.target.style.display = "none")} // Hide on error
              />
            ) : (
              <div></div> // Empty div as fallback
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        className: "text-center oe-action",
        Cell: ({ row }) => (
          <div>
            <button
              onClick={() => {
                setEditTeams(true)
                setId(row.original.id)
                setMembers({
                  value: row.original.member_id,
                  label: row.original.members,
                })
                setCountry({
                  value: row.original.country_id,
                  label: row.original.country,
                })
              }}
              className="btn action-btn btn-sm me-1 btn-outline-secondary"
              aria-label="Edit team"
            >
              <i className="fas fa-pencil-alt"></i>
            </button>
            <Link
              onClick={e => {
                e.preventDefault()
                handleDelete(row.original.id)
              }}
              className="btn btn-sm action-btn btn-danger"
            >
              <i className="fas fa-trash-alt"></i>
            </Link>
          </div>
        ),
      },
    ],
    []
  )

  const toggleLoading = (loading) => {
    setLoading(loading)
  }

  useEffect(() => {
    const loadData = async () => {
      setLoading(true)
      try {
        const response = await fetchNodeData(setLoading, "allLeadsAccess")
        if (response?.success && Array.isArray(response.data)) {
          const transformedData = response.data.map(item => ({
            id: item.id,
            member_id: item.member_id,
            members: item.member_name,
            country_id: item.country_id,
            country: item.country_name,
            country_flag: item.country_flag,
          }))
          setDatas(transformedData)
        } else {
          setDatas([])
          console.warn("No valid data returned from API")
        }
      } catch (error) {
        console.error("Error fetching lead access data:", error)
        setDatas([])
      } finally {
        setLoading(false)
      }
    }
    loadData()
  }, [])

  useEffect(() => {
    const fetchDatas = async () => {
      try {
        const response = await fetchNodeData(
          toggleLoading,
          "allActitvityAccess",
          secureLocalStorage?.getItem("auth_token")
        )
        if (response?.success) {
          console.log("allActitvityAccess", response)
          setStaffData(
            response?.data?.users?.map(obj => ({
              value: obj.id,
              label: obj.name,
            })) || []
          )
        } else {
          console.warn("No valid staff data returned from API")
        }
      } catch (error) {
        console.error("Error fetching staff data:", error)
      }
    }
    if (verticalActiveTabs === "9") {
      fetchDatas()
    }
  }, [verticalActiveTabs])

  const handleDelete = async deleteId => {
    if (!deleteId) {
      Swal.fire("Error!", "No ID provided for deletion.", "error")
      return
    }
    try {
      const res = await FetchNodeDeleteData(
        setLoading,
        "allLeadsAccess",
        deleteId
      )
      if (res?.status === 200 || res?.status === 201) {
        const refreshed = await fetchNodeData(setLoading, "allLeadsAccess")
        if (refreshed?.success && Array.isArray(refreshed.data)) {
          setDatas(
            refreshed.data.map(item => ({
              id: item.id,
              member_id: item.member_id,
              members: item.member_name,
              country_id: item.country_id,
              country: item.country_name,
              country_flag: item.country_flag,
            }))
          )
        } else {
          setDatas([])
        }
        setEditTeams(false)
        setId("")
        setMembers(null)
        setCountry(null)
        Swal.fire("Success!", "Lead Access deleted successfully.", "success")
      } else {
        Swal.fire("Error!", "Failed to delete Lead Access.", "error")
      }
    } catch (error) {
      console.error("Delete error:", error)
      Swal.fire(
        "Error!",
        "An error occurred while deleting the Lead Access.",
        "error"
      )
    }
  }

  const handleAddSubmit = async event => {
    event.preventDefault()
    if (!members || !country) {
      Swal.fire(
        "Error!",
        "Please select a member and a country.",
        "error"
      )
      return
    }
    const newData = {
      member: members.value,
      country: country.value,
    }
    try {
      const res = await FetchNodePostData(setLoading, "allLeadsAccess", newData)
      if (res?.status === 200 || res?.status === 201) {
        const refreshed = await fetchNodeData(setLoading, "allLeadsAccess")
        if (refreshed?.success && Array.isArray(refreshed.data)) {
          setDatas(
            refreshed.data.map(item => ({
              id: item.id,
              member_id: item.member_id,
              members: item.member_name,
              country_id: item.country_id,
              country: item.country_name,
              country_flag: item.country_flag,
            }))
          )
        } else {
          setDatas([])
        }
        setAddTeam(false)
        setMembers(null)
        setCountry(null)
        Swal.fire("Success!", "Lead Communicator added successfully.", "success")
      } else {
        Swal.fire("Error!", "Failed to add Lead Communicator.", "error")
      }
    } catch (error) {
      console.error("Add error:", error)
      Swal.fire("Error!", "An error occurred while adding the Lead Communicator.", "error")
    }
  }

  const handleEditSubmit = async event => {
    event.preventDefault()
    if (!members || !country) {
      Swal.fire(
        "Error!",
        "Please select a member and a country.",
        "error"
      )
      return
    }
    const updatedData = {
      member: members.value,
      country: country.value,
    }
    try {
      const res = await FetchNodePutData(
        setLoading,
        "allLeadsAccess",
        id,
        updatedData
      )
      if (res?.status === 200) {
        const refreshed = await fetchNodeData(setLoading, "allLeadsAccess")
        if (refreshed?.success && Array.isArray(refreshed.data)) {
          setDatas(
            refreshed.data.map(item => ({
              id: item.id,
              member_id: item.member_id,
              members: item.member_name,
              country_id: item.country_id,
              country: item.country_name,
              country_flag: item.country_flag,
            }))
          )
        } else {
          setDatas([])
        }
        setEditTeams(false)
        setMembers(null)
        setCountry(null)
        setId("")
        Swal.fire("Success!", "Lead Communicator updated successfully.", "success")
      } else {
        Swal.fire("Error!", "Failed to update Lead Communicator.", "error")
      }
    } catch (error) {
      console.error("Update error:", error)
      Swal.fire("Error!", "An error occurred while updating the Lead Communicator.", "error")
    }
  }

  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 1200,
    }),
  }

  return (
    <>
      {isLoading && <Loader />}
      <div>
        <Row className="ms-0 pe-0">
          <Col lg={12} className="p-0">
            <Card>
              <CardBody>
                <TableContainer
                  columns={columns}
                  data={datas}
                  setAddTeam={setAddTeam}
                  setAccessDenied={setAccessDenied}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Add Teams Modal */}
      <Modal isOpen={addTeam} centered size="xl">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Add Lead Communicator</h5>
          <button
            type="button"
            onClick={() => setAddTeam(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">×</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleAddSubmit}>
            <Row>
              <div className="col-5">
                <img
                  src={addTeamsImg}
                  className="img-fluid"
                  style={{ minHeight: "350px" }}
                />
              </div>
              <div className="col-7 d-flex align-items-center justify-content-center flex-column">
                <div className="col-12 d-flex align-items-start justify-content-start gap-2 mb-4">
                  <div className="mb-3 col-5">
                    <Label htmlFor="location-select">
                      Select Location <span className="text-danger">*</span>
                    </Label>
                    <Select
                      isMulti={false}
                      placeholder="Select Location"
                      className="basic-multi-select"
                      classNamePrefix="border-radius select"
                      styles={colourStyles}
                      options={getLocations}
                      value={country}
                      onChange={setCountry}
                      id="location-select"
                    />
                  </div>
                </div>
                <div className="col-12 d-flex align-items-start justify-content-start gap-2">
                  <div className="mb-3 col-12">
                    <Label htmlFor="member-select">
                      Select Member <span className="text-danger">*</span>
                    </Label>
                    <Select
                      placeholder="Select Member"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={colourStyles}
                      options={staffData}
                      value={members}
                      onChange={setMembers}
                      id="member-select"
                    />
                  </div>
                </div>
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
              <button type="submit" className="btn btn-save btn-label">
                <i className="fas fa-save me-2 label-icon"></i>
                Submit
              </button>
              <button
                type="button"
                onClick={() => setAddTeam(false)}
                className="btn btn-red btn-label ms-3"
              >
                <i className="dripicons-cross icon-center me-2 label-icon"></i>
                Cancel
              </button>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Edit Teams Modal */}
      <Modal isOpen={editTeams} centered size="xl">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Edit Lead Communicator</h5>
          <button
            type="button"
            onClick={() => setEditTeams(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">×</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleEditSubmit}>
            <Row>
              <div className="col-5">
                <img
                  src={editTeamsImg}
                  className="img-fluid"
                  style={{ minHeight: "350px" }}
                />
              </div>
              <div className="col-7 d-flex align-items-center justify-content-center flex-column">
                <div className="col-12 d-flex align-items-start justify-content-start gap-2 mb-4">
                  <div className="mb-3 col-5">
                    <Label htmlFor="location-select-edit">
                      Select Location <span className="text-danger">*</span>
                    </Label>
                    <Select
                      isMulti={false}
                      placeholder="Select Location"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={colourStyles}
                      options={getLocations}
                      value={country}
                      onChange={setCountry}
                      id="location-select-edit"
                    />
                  </div>
                </div>
                <div className="col-12 d-flex align-items-start justify-content-start gap-2">
                  <div className="mb-3 col-12">
                    <Label htmlFor="member-select-edit">
                      Select Member <span className="text-danger">*</span>
                    </Label>
                    <Select
                      placeholder="Select Member"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={colourStyles}
                      options={staffData}
                      value={members}
                      onChange={setMembers}
                      id="member-select-edit"
                    />
                  </div>
                </div>
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
              <button type="submit" className="btn btn-save btn-label">
                <i className="fas fa-save me-2 label-icon"></i>
                Submit
              </button>
              <button
                type="button"
                onClick={() => setEditTeams(false)}
                className="btn btn-red btn-label ms-3"
              >
                <i className="dripicons-cross icon-center me-2 label-icon"></i>
                Cancel
              </button>
            </div>
          </Form>
        </div>
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </>
  )
}

export default LeadCommunicator